import React, { useRef, useContext, useEffect, useState } from "react";
import { Empty, Table, ConfigProvider, message } from "antd";
import Header from "@/components/Header";
import PAY from "../Price/image/pay.png";
import CONTAINER from "./images/container.png";
import GIFT from "./images/gift.png";
import { getInviteHistory } from "@/apis/vip";
import { DataContext } from "@/context";
import { formatDate } from "@/pages/Price"

import './index.scss';
import { Divider } from "antd";
import { detectDevice } from '@/utils'

interface Props {
    userOtherInfo: any;
    payCountObj: any;
}

const columns = [
  {
    title: '被邀请人',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '日期',
    dataIndex: 'date',
    key: 'date',
    render: (date) => {
        const currentTime = new Date(date)
        const dateString = formatDate(currentTime)
        return dateString
    }
  },
  {
    title: '邀请状态',
    dataIndex: 'status',
    key: 'status',
    render: (text) => {
        if (text === 'REGISTERED') {
            return '已注册'
        } else if (text === 'FIRST_GENERATE_IMAGE') {
            return '已生图'
        } else if (text === 'MULTIPLE_GENERATE_IMAGE') {
            return '已生图'
        } else {
            return '-'
        }
    },
  },
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    date: '2025-01-01',
    status: 1,
  },
  {
    key: '2',
    name: 'John Brown',
    date: '2025-01-01',
    status: 1,
  },
  {
    key: '3',
    name: 'John Brown',
    date: '2025-01-01',
    status: 1,
  },
];

const Invite: React.FC<Props> = (props: Props) => {
    const { userOtherInfo } = props;
    const childRef = useRef<any>(null);
    const isPc = detectDevice()

    const {
        userInfo,
        setContextValue
    } = useContext(DataContext);

    const [messageApi, contextHolder] = message.useMessage();

    const [inviteList, setInviteList] = useState([])

    let start = '专属邀请码 '
    let end = '，限时免费'
    const shareCode = userOtherInfo?.invite_code
    let linkstring = shareCode
      ? 'https://cemeta.cn/#/?y=' + shareCode
      : '未登录'
    // const link = linkstring?.slice(linkstring.indexOf('http'));

    const handleCopy = async () => {
        if (userInfo?.user_id && linkstring && linkstring !== '未登录') {
            try {
                const shareText = '森宇宙好绘AI PS插件\n先进AI设计功能+大额商单接单，免费体验!\n我的邀请码' + shareCode + '，点击链接注册→\n' + linkstring
                await navigator.clipboard.writeText(shareText);
                messageApi.open({
                  type: 'success',
                  content: '复制成功',
                });
                // console.log('复制成功');
                // 可选：提示用户
                // alert('已复制到剪贴板');
              } catch (err) {
                console.error('复制失败:', err);
                // 回退到老方法
                // fallbackCopy(text);
              }
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }

    const renderEmpty = (componentName) => {
        if (componentName === 'Table' /** 👈 5.20.0+ */) {
          return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据" />;
        }
      };

    useEffect(() => {
        const work1 = async () => {
            const result = await getInviteHistory({
                limit: 10000,
                offset: 0
            }).catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            if (result?.count && Array.isArray(result?.list)) {
                const newArray = result?.list?.map(item => ({
                    id: item?.id,
                    name: item?.nickname,
                    status: item?.state,
                    date: item?.register_time 
                }))
                setInviteList(newArray)
            } else {
                setInviteList([])
            }
        };
        if (userInfo?.user_id) {
            work1();
        } else {
            setInviteList([])
        }
       
    }, [userInfo?.user_id])

  return (
    <>
        {contextHolder}
        <div className="invite"> 
            <Header ref={childRef} cssStyle={{ zIndex: 20, background: 'transparent' }} {...props} />
            <div className="wapper" style={isPc ? { marginTop: '100px' } : { marginTop: '10em' }}>
                <div className="invite-title" style={isPc ? {} : { fontSize: '2.5em', lineHeight: '3em'}}>
                    <span>邀请好友得算力</span>
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '34px' }}>
                <div className="invite-des">
                    <Divider style={{ width: '12px', background: '#929396', margin: '8px 4px' }} /><span>已获得</span><Divider style={{ width: '12px', background: '#929396', margin: '8px 4px' }} />
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '6px' }}>
                <div className="invite-count">
                    <img style={{ width: '24px', height: '24px', marginRight: '8px' }} src={PAY} alt="pay" /> 
                    <span style={{ marginRight: '8px', color: '#376BFF' }}>{userOtherInfo?.earned_credits_by_invite || 0}</span> 
                    <span>算力</span> 
                </div>
            </div>
            <div className="wapper">
                <div className="invite-divider">
                    <Divider style={{ width: '280px', background: '#383a3e', margin: '24px 0px' }} />
                </div>
            </div>
            <div className="wapper">
                <div className="invite-gift">
                    <img style={{ width: '30px', height: 'auto', marginRight: '4px' }} src={GIFT} />
                    <span>邀请成功奖励</span>
                    <span style={{ color: '#376BFF', marginLeft: '4px', marginRight: '4px', fontSize: '22px' }}>300</span>
                    <span>算力/人（限时活动奖励加倍）</span>
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '16px' }}>
                <div className="invite-list">
                    {/* <div className="invite-list-item"> */}
                        <span>· 被邀请人通过推荐人发送的邀请码进行注册，并完成一次生图任务，推荐人可获得推广奖励</span>
                        {/* <span>· 每邀请10个用户，可免费获得1张「7天会员权益」兑换码，可前往注册邮箱领取</span> */}
                    {/* </div> */}
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '44px' }}>
                <div className="invite-link">
                    <div className="invite-link-title">
                        <span>邀请链接和专属邀请码</span>
                    </div>
                    <div className="invite-link-address" style={isPc ? { marginTop: '12px' } : { marginTop: '12px', flexDirection: 'column' }}>
                        <div className="invite-link-address-url" style={isPc ? { marginRight: '12px' } : { marginRight: '12px', width: '100%' }}>
                            <span>{linkstring}</span>
                        </div>
                        <div className="invite-link-address-button"  style={isPc ? {} : { marginTop: '16px' }} onClick={handleCopy}>
                            <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={CONTAINER} />
                            <span>点击复制</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '56px' }}>
                <div className="invite-broad" style={isPc ? {} : { fontSize: '2.5em', lineHeight: '3em'}}>
                    <span>推广明细</span>
                </div>
            </div>
            <div className="wapper" style={{ marginTop: '24px', paddingBottom: '16px' }}>
                <ConfigProvider renderEmpty={renderEmpty}>
                    <Table 
                        className="invite-table"
                        style={{ width: '90%' }}
                        rowClassName={(record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')} 
                        pagination={false} 
                        columns={columns} 
                        dataSource={inviteList} 
                        />
                        </ConfigProvider>
            </div>
        </div>
    </>

  );
};

export default Invite;
